import {Religion} from '../../backend/enums/religion';
import {translations} from '../../i18n/translations';

/**
 * Array with the available religion in the Backend.
 *
 * Note: The property 'translation' gives the translation path to be used with i18n.
 * Example: t(religions[0].translation)
 * We don't return the translated value, because once set the values won't change.
 * Thus, if the user updates his language on the profile, the values given by this
 * array won't change and translate to the new language set by the user.
 */
export const religions: Array<{translation: string; type: Religion}> = [
  {
    translation: translations.religions[Religion.AfricanTraditionalAndDiasporic],
    type: Religion.AfricanTraditionalAndDiasporic,
  },
  {translation: translations.religions[Religion.Agnostic], type: Religion.Agnostic},
  {
    translation: translations.religions[Religion.Animism],
    type: Religion.Animism,
  },
  {
    translation: translations.religions[Religion.Atheist],
    type: Religion.Atheist,
  },
  {
    translation: translations.religions[Religion.BahaI],
    type: Religion.BahaI,
  },
  {
    translation: translations.religions[Religion.Buddhism],
    type: Religion.Buddhism,
  },
  {
    translation: translations.religions[Religion.CaoDai],
    type: Religion.CaoDai,
  },
  {
    translation: translations.religions[Religion.ChineseTraditionalReligion],
    type: Religion.ChineseTraditionalReligion,
  },
  {
    translation: translations.religions[Religion.Christianity],
    type: Religion.Christianity,
  },
  {
    translation: translations.religions[Religion.Hinduism],
    type: Religion.Hinduism,
  },
  {
    translation: translations.religions[Religion.Islam],
    type: Religion.Islam,
  },
  {
    translation: translations.religions[Religion.Jainism],
    type: Religion.Jainism,
  },
  {
    translation: translations.religions[Religion.Juche],
    type: Religion.Juche,
  },
  {
    translation: translations.religions[Religion.Judaism],
    type: Religion.Judaism,
  },
  {
    translation: translations.religions[Religion.NeoPaganism],
    type: Religion.NeoPaganism,
  },
  {
    translation: translations.religions[Religion.Nonreligious],
    type: Religion.Nonreligious,
  },
  {
    translation: translations.religions[Religion.PrimalIndigenous],
    type: Religion.PrimalIndigenous,
  },
  {
    translation: translations.religions[Religion.Rastafari],
    type: Religion.Rastafari,
  },
  {
    translation: translations.religions[Religion.Secular],
    type: Religion.Secular,
  },
  {
    translation: translations.religions[Religion.Shinto],
    type: Religion.Shinto,
  },
  {
    translation: translations.religions[Religion.Sikhism],
    type: Religion.Sikhism,
  },
  {
    translation: translations.religions[Religion.Spiritism],
    type: Religion.Spiritism,
  },
  {
    translation: translations.religions[Religion.Tenrikyo],
    type: Religion.Tenrikyo,
  },
  {
    translation: translations.religions[Religion.Undisclosed],
    type: Religion.Undisclosed,
  },
  {
    translation: translations.religions[Religion.UnitarianUniversalism],
    type: Religion.UnitarianUniversalism,
  },
  {
    translation: translations.religions[Religion.Unspecified],
    type: Religion.Unspecified,
  },
  {
    translation: translations.religions[Religion.Zoroastrianism],
    type: Religion.Zoroastrianism,
  },
];
